export class RegisterFormModel {
  password = '';
  email = '';
}
